import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { RosterPage } from '@/features/roster'

export const Route = createFileRoute('/_authenticated/_organization/roster/')({
  beforeLoad: async () => requireRoles(['health_carer', 'supported_employee']),
  component: RosterPage,
})

